"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconUrl = void 0;

var _legacyHubspotBenderContext = require("legacy-hubspot-bender-context");

// import-eslint-disable-line
var getIconUrl = function getIconUrl(set, iconName) {
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  return _legacyHubspotBenderContext.bender.staticDomainPrefix + "/content-icons-ui/" + _legacyHubspotBenderContext.bender.depVersions['content-icons-ui'] + "/images/" + set + "/" + iconName + "/" + style + ".svg";
};

exports.getIconUrl = getIconUrl;